const DISABLE_SCROLL = 'DISABLE_SCROLL';
const ENABLE_SCROLL = 'ENABLE_SCROLL';
const ENABLE_SCROLL_MOBILE = 'ENABLE_SCROLL_MOBILE';
const DISABLE_SCROLL_MOBILE = 'DISABLE_SCROLL_MOBILE';

const events = [
  DISABLE_SCROLL,
  ENABLE_SCROLL,
  ENABLE_SCROLL_MOBILE,
  DISABLE_SCROLL_MOBILE,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);
};

export const BODY_STYLES_EVENTS = {
  initializeEventListeners,
  DISABLE_SCROLL,
  ENABLE_SCROLL,
  DISABLE_SCROLL_MOBILE,
  ENABLE_SCROLL_MOBILE,
};
